import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from './ScrollView.commonHtml.js.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  beforeSetup1a13mbd699ddp as beforeSetup,
  beforeSetupsr6thgzteo9n as beforeSetup_0,
} from '../ElementWriter.ext.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SizeConstraints24axz83pb17aw as SizeConstraints } from '../../models/data.mjs';
import { sizedBox3aolxerximlpj as sizedBox } from './modifiers.commonHtml.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../models/data.commonHtml.mjs';
import { set_padding5v7ifiir6y9y as set_padding } from '../Element.ext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_scrolling(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var vertical = true;
  var horizontal = false;
  return beforeSetup(_this__u8e3s4, ($this$beforeSetup) => {
    new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical);
    return Unit_instance;
  });
}
function sizeConstraints(_this__u8e3s4, minWidth, maxWidth, minHeight, maxHeight, aspectRatio, width, height) {
  minWidth = minWidth === VOID ? null : minWidth;
  maxWidth = maxWidth === VOID ? null : maxWidth;
  minHeight = minHeight === VOID ? null : minHeight;
  maxHeight = maxHeight === VOID ? null : maxHeight;
  aspectRatio = aspectRatio === VOID ? null : aspectRatio;
  width = width === VOID ? null : width;
  height = height === VOID ? null : height;
  return sizedBox(_this__u8e3s4, new (SizeConstraints())(minWidth, maxWidth, minHeight, maxHeight, aspectRatio, width, height));
}
function get_unpadded(_this__u8e3s4) {
  return beforeSetup_0(_this__u8e3s4, _get_unpadded_$lambda_gmu3op);
}
function get_scrollingHorizontally(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var vertical = false;
  var horizontal = true;
  return beforeSetup(_this__u8e3s4, ($this$beforeSetup) => {
    new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical);
    return Unit_instance;
  });
}
function _get_unpadded_$lambda_gmu3op($this$beforeSetup) {
  set_padding($this$beforeSetup, get_px(0));
  return Unit_instance;
}
//region block: exports
export {
  get_scrolling as get_scrolling3fwkltztkpfe8,
  get_scrollingHorizontally as get_scrollingHorizontally27coz76tiofr2,
  sizeConstraints as sizeConstraints19w9rda6g3rqz,
  get_unpadded as get_unpadded1ygmnwh0rw79t,
};
//endregion

//# sourceMappingURL=modifiers.mjs.map
